import {
  DEFAULT_SETTINGS,
  fonts,
  placements,
  TFonts,
  TPlacements
} from '../../../constants/settings';

export interface ISettings {
  font: TFonts[number];
  placement: TPlacements[number];
  fontSize: number;
  lineHeight: number;
  timePerLine: number;
  transparency: number;
}

export const initialSettings: ISettings = {
  font: fonts[0],
  placement: placements[0],
  fontSize: DEFAULT_SETTINGS.font_size,
  lineHeight: DEFAULT_SETTINGS.font_size * DEFAULT_SETTINGS.line_height_factor,
  timePerLine: 2,
  transparency: 20
};
